// Traditional Chinese (Taiwan). Keys omitted here fall back to English (see
// src/i18n/index.js). "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': '取消',
  'common.submit': '送出',
  'common.save': '儲存',
  'common.create': '建立',
  'common.delete': '刪除',
  'common.close': '關閉',
  'common.retry': '重試',
  'common.confirm': '確認',
  'common.areYouSure': '確定要繼續嗎？',

  'chat.startConversation': '開始對話',
  'chat.inputPlaceholder': '輸入訊息...',
  'chat.inputPlaceholderNoCredits': 'RPilot 額度已用完',
  'chat.creditsUsedUpFooter': '你團隊的 RPilot 額度已用完。額度續訂後請開始新的聊天。',
  'chat.newChat': '新聊天',
  'chat.useSkill': '使用技能',
  'chat.skills': '技能',
  'chat.loadingSkills': '正在載入技能…',
  'chat.noSkill': '不使用技能',
  'chat.noSkillsAvailable': '沒有可用的技能',
  'chat.appliesNextMessage': '將從你的下一則訊息開始生效',
  'chat.attachImage': '附加圖片',
  'chat.attachFile': '附加檔案',
  'chat.fileTooLarge': '檔案太大（上限 {size}）',
  'chat.uploadFailed': '上傳失敗',
  'chat.download': '下載',
  'chat.recordVoice': '錄製語音',
  'chat.stopRecording': '停止錄音',
  'chat.stop': '停止',
  'chat.send': '傳送',
  'chat.thinking': '思考中…',
  'chat.thoughtProcess': '思考過程',
  'chat.waitingForHost': '正在等待儀表板…',
  'chat.thinkingComplete': '思考完成',
  'chat.toolUsedOne': '已使用 1 個工具',
  'chat.toolsUsedCount': '已使用 {count} 個工具',
  'chat.usedNames': '已使用 {names}',
  'chat.usedToolsCount': '已使用 {count} 個工具',
  'chat.running': '執行中',
  'chat.details': '詳細資訊',
  'chat.arguments': '參數',
  'chat.result': '結果',
  'chat.error': '錯誤',
  'chat.done': '完成',
  'chat.openInNewTab': '在新分頁開啟',
  'chat.openInDocsSite': '在文件網站開啟',
  'chat.noPageContent': '此頁面沒有可用內容。',
  'chat.goodResponse': '回答得好',
  'chat.badResponse': '回答不佳',
  'chat.whatWentWrong': '哪裡出了問題？',
  'chat.optionalFeedback': '選填回饋...',

  'approval.required': '需要核准',
  'approval.requiredCount': '需要核准 — {count} 項操作',
  'approval.approve': '核准',
  'approval.deny': '拒絕',
  'approval.approveAll': '全部核准',
  'approval.approveSelected': '核准所選（{count}）',
  'approval.denyAll': '全部拒絕',
  'approval.andMore': '…還有 {count} 項',
  'approval.approvedChip': '已核准',
  'approval.deniedChip': '已拒絕',
  'approval.timedOutChip': '已逾時',
  'approval.countApproved': '{count} 項已核准',
  'approval.countDenied': '{count} 項已拒絕',
  'approval.countTimedOut': '{count} 項已逾時',
  'approval.timedOut': '已逾時',
  'approval.settled': '已處理',

  'header.expand': '展開',
  'header.collapse': '收合',
  'header.menu': '選單',
  'drawer.sessions': '工作階段',
  'drawer.skills': '技能',
  'drawer.settings': '設定',
  'drawer.noSessions': '尚無工作階段',
  'drawer.chatFallbackTitle': '聊天 {id}',
  'drawer.newSkill': '新增技能',
  'drawer.searchSkills': '搜尋技能...',
  'drawer.noSkillsMatch': '沒有符合搜尋條件的技能。',
  'drawer.noSkillsYet': '還沒有技能。建立一個開始吧。',
  'drawer.mySkills': '我的技能',
  'drawer.builtIn': '內建',
  'drawer.shared': '已共用',
  'drawer.showToolCalls': '顯示工具呼叫',
  'drawer.autoAcceptEdits': '自動接受編輯',
  'drawer.darkMode': '深色模式',
  'drawer.version': '版本',
  'drawer.versionCopied': '已複製',

  'gate.meetTitle': '認識 RPilot',
  'gate.meetBody': 'RPilot 是你在 RDrive 中的 AI 助理。用日常語言詢問圖面、問題、時程與專案資料，即可獲得清楚的回答以及直接連往應用程式的連結。',
  'gate.meetCta': '想為你的團隊使用 RPilot？請聯絡我們的銷售團隊',
  'gate.outOfCreditsTitle': '你的 RPilot 額度已用完',
  'gate.outOfCreditsBody': '你團隊的 RPilot 額度已用完。請聯絡我們續訂，並從上次中斷的地方繼續。',
  'credits.title': '額度使用情況',
  'credits.loadFailed': '無法載入額度使用情況。',
  'credits.active': '目前使用',
  'credits.fallback': '備用',
  'credits.exhausted': '已用盡',
  'credits.noPools': '沒有額度池',
  'credits.daily': '每日',
  'credits.weekly': '每週',
  'credits.monthly': '每月',
  'credits.dayShort': '日',
  'credits.weekShort': '週',
  'credits.monthShort': '月',
  'credits.usedNoLimit': '{label} — 已使用 {spent}（無限制）',
  'credits.balanceLine': '餘額：{balance} 點額度 · 於 {zone} 午夜重設',
  'credits.account': '帳戶',
  'credits.scopeProject': '專案',
  'credits.scopeTeam': '團隊',
  'credits.scopeMixed': '混合',
  'credits.scopePool': '額度池',
  'credits.messageNotSent': '你團隊的 RPilot 額度已用完，因此無法傳送此訊息。你的對話已儲存。',
  'credits.contactUs': '聯絡我們',

  'sales.contactSales': '聯絡銷售',
  'sales.requestReceived': '已收到請求 ✓',
  'sales.submitAgain': '再次送出',
  'sales.name': '姓名',
  'sales.workEmail': '工作電子郵件',
  'sales.companyTeam': '公司/團隊（選填）',
  'sales.message': '留言（選填）',
  'sales.nameRequired': '請填寫姓名',
  'sales.emailRequired': '請填寫工作電子郵件',
  'sales.emailInvalid': '請輸入有效的電子郵件地址',
  'sales.thanks': '謝謝——我們的團隊會與你聯絡。',
  'sales.alreadyReceived': '我們已收到你的請求——我們會與你聯絡。',
  'sales.genericError': '發生問題，請重試。',
  'sales.speakWithSales': '聯絡銷售',
  'sales.salesChatPrefill': '您好，我想洽詢為我的團隊開通 RPilot 的銷售事宜。',


  'skill.newSkill': '新增技能',
  'skill.editTitle': '編輯 — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': '這是由 RDrive 維護的內建技能，無法編輯。如需針對此專案進行自訂，請建立一個同名的共用技能，它將在此處優先生效。',
  'skill.name': '名稱',
  'skill.nameHint': 'kebab-case 識別碼',
  'skill.nameRule': '必須為 kebab-case（例如 review-rfi）',
  'skill.shared': '共用',
  'skill.description': '描述',
  'skill.descriptionPlaceholder': '這個技能的用途及使用時機',
  'skill.required': '必填',
  'skill.tags': '標籤',
  'skill.tagsPlaceholder': '輸入後按 Enter',
  'skill.allowedTools': '允許的工具',
  'skill.allToolsAllowed': '允許所有工具',
  'skill.instructions': '說明（Markdown）',
  'skill.contentRequired': '內容為必填',
  'skill.deleteTitle': '刪除技能',
  'skill.deleteMessage': '刪除技能「{name}」？此操作無法復原。',

  'picker.selectLocation': '選擇位置',
  'picker.searchDrawings': '搜尋圖面...',
  'picker.planViewerFailed': '無法載入圖面檢視器',
  'picker.selectDrawing': '選擇要檢視的圖面',
  'picker.tapToPlace': '點選位置圖釘以放置問題',
  'picker.pinPlaced': '已放置圖釘',

  'md.bold': '粗體',
  'md.italic': '斜體',
  'md.heading': '標題',
  'md.inlineCode': '行內程式碼',
  'md.codeBlock': '程式碼區塊',
  'md.link': '連結',
  'md.bulletList': '項目符號清單',
  'md.numberedList': '編號清單',
  'md.blockquote': '引用',
  'md.nothingToPreview': '沒有可預覽的內容',
}
